// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pnCJ","field":"styles_field__3fWIy","fieldCol":"styles_fieldCol__69DEG","diffCol":"styles_diffCol__3KWVd","diff":"styles_diff__3A4QX"};